const CDN_V_CONSOLE = "https://app-h5.gwmapp-h.com/app-web/SDK/vconsole.min.js";
const setConsole = (cb, eb) => {
  const bodyEl = document.getElementsByTagName("body")[0];
  const el = document.createElement("script");
  el.src = CDN_V_CONSOLE;
  el.type = "text/javascript";
  el.onload = cb;
  el.onerror = eb;
  bodyEl.appendChild(el);
};

const env = process.env.VUE_APP_EV;

if (env === "dev" || env === "test" || env === "sit") {
  setConsole(
    () => {
      // eslint-disable-next-line no-new, no-undef
      new VConsole();
    },
    () => {}
  );
}
